import {OverlayModule} from '@angular/cdk/overlay';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {NzTimePickerPanelComponent} from './nz-time-picker-panel.component';
import {NzTimePickerComponent} from './nz-time-picker.component';
import {NzTimeValueAccessorDirective} from './nz-time-value-accessor.directive';
import {JdI18nModule} from "../i18n/nz-i18n.module";

@NgModule({
  declarations: [
    NzTimePickerComponent,
    NzTimePickerPanelComponent,
    NzTimeValueAccessorDirective
  ],
  exports: [
    NzTimePickerPanelComponent,
    NzTimePickerComponent
  ],
  imports: [CommonModule, FormsModule, JdI18nModule, OverlayModule],
  entryComponents: []
})
export class JdTimePickerModule {
}
